export { default } from './Toolbar';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/Toolbar/index.js
// module id = 200
// module chunks = 2